import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TableHeader from '@shared/components/tables/table-header/table-header.vue';
import InvoiceForm from '@accounting/components/forms/invoice-form/invoice-form.vue';
import moment from 'moment';
import PosTicketTabs from '../pos-ticket-tabs/pos-ticket-tabs.vue';
import PosPrintTicket from '../pos-print-ticket/pos-print-ticket.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
@Component({
  name: 'bpc-pos-invoice-checkout',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-table-header': TableHeader,
    'bpc-pos-ticket-tab': PosTicketTabs,
    'bpc-invoice-form': InvoiceForm,
    'bpc-pos-print-ticket': PosPrintTicket,
  },
})
export default class PosInvoiceCheckout extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    invoiceForm: InstanceType<typeof InvoiceForm> & {
      saveEntity(): void;
      formModel: Invoice;
    };
    posTicketTab: InstanceType<typeof PosTicketTabs> & {
      onClick(id): void;
    };
  };

  mounted() {
    this.$root.$on('invoiceContactChangedFromPosInvoiceFormToPosInvoiceCheckout', event => {
      this.onUpdateForm();
    });
    this.$root.$on('invoicePriceCategoryChangedFromPosInvoiceFormToPosInvoiceCheckout', event => {
      this.onUpdateForm();
    });
  }

  destroyed() {
    this.$root.$off('invoiceContactChangedFromPosInvoiceFormToPosInvoiceCheckout');
    this.$root.$off('invoicePriceCategoryChangedFromPosInvoiceFormToPosInvoiceCheckout');
  }
  /**
   * FORM ATTRIBUTES */

  public showForm: boolean = false;
  public entity: AnyEntity = null;
  public isSavingForm: boolean = false;
  /**
   * END FORM ATTRIBUTES
   */

  onClickClose(): void {
    this.$store.commit('pos/closeDrawer');
  }

  public newTicketSubscription = null;
  public updateTicketSubscription = null;

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }
  onNewTicket($event = null): void {
    this.isSavingForm = true;
    this.$store.commit('pos/clearCurrentTicket');
    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'invoice',
      this.lang,
    )}/pos/create-ticket`;
    const data = { pos_session_id: this.openPosSessionId };
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.newTicketSubscription) {
      this.newTicketSubscription.unsubscribe();
    }
    this.newTicketSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.onFormSaved(res);
        this.isSavingForm = false;
      },
      error => {
        this.isSavingForm = false;
      },
    );

    // DEPRECATED BECAUSE NOW CREATE DIRECTLY TICKETS WHEN CLICK ON + BUTTON INSTEAD OF SHOW THE FORM
    // this.resetForm();
    // setTimeout(() => {
    //   this.onNew();
    // });
  }
  /**
   * FORM FUNCTIONALITY
   */
  resetForm() {
    this.entity = null;
  }
  onNew() {
    this.entity = null;
    this.showForm = true;
  }

  onFormSaved($event: any = null) {
    // See eventsConfig of the tab filter on order-items
    this.$store.commit('pos/storeCurrentTicketId', $event.data.id);
    this.$store.commit('pos/storeNewTicketToOpenTickets', $event.data);
    // Expand drawer when create a ticket
    const el = document.body;
    el.classList.add('pos-checkout-opened');
    if (!this.$store.getters['pos/posExpanded']) {
      this.$store.commit('pos/togglePosExpanded');
    }
  }

  onEdit(e) {
    this.resetForm();
    this.entity = { id: e };
    this.showForm = true;
  }
  /**
   * END FORM FUNCTIONALITY
   */

  /**
   * START FORM WRAPPER FUNCTIONALITY
   */
  isUpdatingForm: boolean = false;
  onClickCancel() {
    this.resetForm();
  }
  async onUpdateForm() {
    if (this.entity && this.entity.id) {
      this.isUpdatingForm = true;
      const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
        'invoice',
        this.lang,
      )}/pos/update-ticket/${this.$refs.invoiceForm?.formModel?.id}`;
      const data = {
        id: this.$refs.invoiceForm?.formModel?.id,
        contact_id: this.$refs.invoiceForm?.formModel?.contact?.id || null,
        price_category_id: this.$refs.invoiceForm?.formModel?.price_category?.id || null,
      };
      const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

      if (this.updateTicketSubscription) {
        this.updateTicketSubscription.unsubscribe();
      }
      this.updateTicketSubscription = observable.subscribe(
        (res: BPCGenericApiResponse) => {
          this.isUpdatingForm = false;
        },
        error => {
          this.isUpdatingForm = false;
        },
      );
    }
  }

  /**
   *
   */
  get showDrawer(): boolean {
    return this.$store.getters['pos/showDrawer'];
  }

  get openPosSessionId(): number {
    return this.$store.getters['pos/openPosSessionId'];
  }
  get currentTicket(): Invoice {
    return this.$store.getters['pos/currentTicket'];
  }
  get currentTicketId(): number {
    return this.$store.getters['pos/currentTicketId'];
  }
  get orderItems(): [] {
    return this.$store.getters['pos/orderItems'];
  }
  get posUserName() {
    const posSession = this.$store.getters['pos/openPosSession'];
    return posSession?.profile.user.name;
  }

  get openTickets() {
    return this.$store.getters['pos/openTickets'];
  }

  @Watch('currentTicketId')
  onChangeCurrentTicketId() {
    this.showForm = false;
    setTimeout(() => {
      if (this.currentTicketId) {
        this.onEdit(this.currentTicketId);
      } else {
        this.onNew();
      }
    });
  }

  @Watch('openTickets')
  onChangeOpenTickets() {
    if (this.openTickets.length === 0) {
      this.onNew();
    }
  }
}
